module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa formularza",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis formularza",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tekst podziękowania",
      "error": _vm.errors[_vm.addLanguageSuffix('thanks')]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('thanks')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('thanks'), $$v)
      },
      expression: "form[addLanguageSuffix('thanks')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Adres email, na który będą wysyłane powiadomienia",
      "error": _vm.errors.notifications_email
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.notifications_email),
      callback: function($$v) {
        _vm.$set(_vm.form, "notifications_email", $$v)
      },
      expression: "form.notifications_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tekst na przycisku zatwierdzenia",
      "error": _vm.errors[_vm.addLanguageSuffix('button_text')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('button_text')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('button_text'), $$v)
      },
      expression: "form[addLanguageSuffix('button_text')]"
    }
  })], 1), _vm._v(" "), (!_vm.form.id || _vm.form.formdata_set.length === 0) ? _c('div', [_c('sections', {
    attrs: {
      "sections": _vm.form.sections,
      "fieldTypes": _vm.fieldTypes,
      "errors": _vm.errors.sections || []
    },
    on: {
      "update:sections": function($event) {
        return _vm.$set(_vm.form, "sections", $event)
      }
    }
  })], 1) : _c('el-alert', {
    attrs: {
      "title": "Brak możliwości edycji sekcji",
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n                      Jeżeli formularz posiada już zgłoszenia nie można edytować jego pól.\n                    ")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1163fc54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CustomForms/CustomForm.vue
// module id = 713
// module chunks = 0